var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

function MyCoursesBlock(params) {
  this.API = params.api;
  this.links = params.links;
  this.texts = params.texts;
  this.numberOfOnlineCourses = ko.observable();
  this.numberOfRegularCourses = ko.observable();

  this.getNumberOfPlannedCourses();
}

MyCoursesBlock.prototype.getNumberOfPlannedCourses = function() {
  var self = this,
    url = this.API.numberOfPlannedCoursesUrl;

  APIHelper.get(url, function(response) {
    self.numberOfRegularCourses(response.Item1);
    self.numberOfOnlineCourses(response.Item2);
  });
};

module.exports = MyCoursesBlock;
